import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Button from 'components/common/Button/Button'

const ApplySavingsButton = ({ onClick, disabled, ...props }) =>
  <StyledButton
    { ...props }
    disabled={ disabled }
    important
    full="mobile"
    onClick={ onClick }>Apply Savings
  </StyledButton>

ApplySavingsButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func
}

const StyledButton = styled(Button)`
  margin: 0 0 30px;
`

export default ApplySavingsButton
